import { css } from 'styled-components';
import { COLORS } from '../BaseColors';
import { hover } from '../../styling';
import { TYPOGRAPHY_BASE } from '../BaseTypography';
export var defaultTypography = /*#__PURE__*/css(["body{p{", ";a{border-radius:4px;", ";}}}"], TYPOGRAPHY_BASE.M, hover('color', COLORS.PRIMARY_500, COLORS.PRIMARY_700));